
import Vue from 'vue';

export default Vue.extend({
	name: 'ComplexBackgroundBaseStyledMenu',
	props: {
		includeLeftBlobs: { type: Boolean, default: false },
		top: { type: Number, default: -140 },
		left: { type: Number, default: 110 },
	},
	data () {
		return {};
	},
});
